document.addEventListener('DOMContentLoaded', () => {
  // Product grid container (product-grid snippet içinde #ResultsList var)
  const resultsList = document.querySelector('#ResultsList');
  const loadMoreWrapper = document.querySelector('[data-load-more-wrapper]');
  const loadMoreButton = document.querySelector('[data-load-more-btn]');
  const spinner = document.querySelector('[data-load-more-spinner]');

  if (!resultsList || !loadMoreWrapper || !loadMoreButton) return;

  const originalLabel = loadMoreButton.textContent.trim();

  async function handleClick() {
    const nextUrl = loadMoreButton.dataset.nextUrl;
    if (!nextUrl) return;

    loadMoreButton.disabled = true;
    loadMoreButton.textContent = 'Loading...';
    if (spinner) spinner.hidden = false;

    try {
      const response = await fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Network error');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Yeni sayfadaki ürün listesi (#ResultsList)
      const newResultsList = doc.querySelector('#ResultsList');
      if (!newResultsList) {
        throw new Error('ResultsList not found on next page');
      }

      const newItems = Array.from(newResultsList.children);
      newItems.forEach((item) => {
        if (item.tagName && item.tagName.toLowerCase() !== 'script') {
          resultsList.appendChild(item);
        }
      });

      // Yeni sayfanın "Load more" butonundan next-url’i al
      const newButton = doc.querySelector('[data-load-more-btn]');
      const newNextUrl = newButton?.dataset.nextUrl;

      if (newNextUrl) {
        loadMoreButton.dataset.nextUrl = newNextUrl;
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = originalLabel;
      } else {
        // Son sayfa: butonu gizle
        loadMoreWrapper.hidden = true;
      }
    } catch (error) {
      console.error(error);
      loadMoreButton.disabled = false;
      loadMoreButton.textContent = 'Try again';
    } finally {
      if (spinner) spinner.hidden = true;
    }
  }

  loadMoreButton.addEventListener('click', handleClick);
});
